import { RpcProvider } from 'starknet';
import { HTLCPublicClient, } from '@train-protocol/sdk';
import { getUserLockDetails } from './public/getUserLockDetails.js';
import { getSolverLockDetails } from './public/getSolverLockDetails.js';
import { recoverSwap } from './public/recoverSwap.js';
import { getTransaction } from './public/getTransaction.js';
export class StarknetHTLCPublicClient extends HTLCPublicClient {
    constructor(config) {
        super();
        this.provider = new RpcProvider({ nodeUrl: config.rpcUrl });
        this.consensusOptions = { minQuorum: 1, batchSize: 1 };
    }
    async getUserLockDetails(params) {
        return getUserLockDetails(this.provider, params);
    }
    async getSolverLockDetails(params, nodeUrl) {
        return getSolverLockDetails(params, nodeUrl);
    }
    async recoverSwap(txHash, network) {
        return recoverSwap(this.provider, txHash, network);
    }
    async getTransaction(txHash) {
        return getTransaction(this.provider, txHash);
    }
}
